import { Button } from '@cloudscape-design/components';
import { useContext, useEffect, useState } from 'react';
import { format } from 'date-and-time';
import {
  documentTableItem,
  IDocumentComment
} from '../../../lib/models/interfaces';
import { UserContext } from '../../../context/authContext';
import axios from 'axios';
import { Trash2 } from 'lucide-react';

interface DocumentCommentsProps {
  documentIds: documentTableItem[];
  carouselIndex: number;
}

export const DocumentComments = ({
  documentIds,
  carouselIndex
}: DocumentCommentsProps) => {
  const { auth, token, user } = useContext(UserContext);
  const [newComment, setNewComment] = useState<string>('');
  const [allComments, setAllComments] = useState<{
    [key: string]: IDocumentComment[];
  }>({});

  const getDocumentComments = async () => {
    try {
      const temp: { [key: string]: IDocumentComment[] } = {};
      for (const doc of documentIds) {
        const res = await axios.post(
          `${process.env.REACT_APP_KORU_API}/document?type=commentsByDocument`,
          { documentId: doc._id },
          auth
        );
        temp[doc._id] = res.data.result;
      }
      setAllComments(temp);
    } catch (e) {
      console.log('error from getallcomments', e);
    }
  };
  useEffect(() => {
    if (!token) return;
    getDocumentComments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentIds, token]);

  const postComment = async () => {
    try {
      const documentId = documentIds[carouselIndex]._id;
      const res = await axios.post(
        `${process.env.REACT_APP_KORU_API}/document?type=addDocumentComment`,
        { documentId, comment: newComment },
        auth
      );
      console.log('comment', res.data);

      if (!allComments) {
        setAllComments({ [documentId]: [res.data.result] });
      } else {
        setAllComments((prev) => ({
          ...prev,
          [documentId]: [...(prev[documentId] ?? []), res.data.result]
        }));
      }
      setNewComment('');
    } catch (e) {
      console.log('error', e);
    }
  };
  const deleteComment = async (id: string, documentId: string) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_KORU_API}/document?type=deleteDocumentComment`,
        { commentId: id },
        auth
      );
      console.log('comment', res.data);

      setAllComments((prev) => ({
        ...prev,
        [documentId]: [...prev[documentId].filter((c) => c._id !== id)]
      }));
    } catch (e) {
      console.log('error', e);
    }
  };

  useEffect(() => {
    const filteredEntries = Object.entries(allComments).filter(
      ([, comments]) => comments?.length
    );

    if (filteredEntries.length === Object.keys(allComments).length) return;

    const cleanedComments = filteredEntries.reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: value
      }),
      {} as { [key: string]: IDocumentComment[] }
    );

    setAllComments(cleanedComments);
  }, [allComments]);

  return (
    <div className="h-[100%] bg-green min-h-[75vh]">
      <div
        className="h-[55vh] p-4 space-y-3 overflow-y-scroll"
        style={{ scrollbarWidth: 'none' }}
      >
        {Object.keys(allComments).length > 0 &&
          Object.keys(allComments).map((document) => {
            return (
              <>
                <div className="w-full text-center border rounded-xl bg-[#56dac5]">
                  {
                    documentIds.filter((doc) => doc._id === document)[0]
                      .documentFileName
                  }
                </div>
                <div className="space-y-2 mt-2">
                  {allComments[document].map((ele, index) => {
                    return (
                      <div
                        className={`border rounded-xl p-4 text-left bg-slate-100 `}
                      >
                        <div className="w-full flex justify-between ">
                          <span className="italic">{ele.createdBy.name}:</span>
                          <span className="italic">
                            {format(
                              new Date(ele.createdAt),
                              'ddd, MMM DD YYYY'
                            )}
                          </span>
                          <span
                            className="text-xxs"
                            onClick={() =>
                              deleteComment(ele?._id!, ele.documentId)
                            }
                          >
                            {ele.createdBy.sub === user.sub && (
                              <Trash2 size={16} />
                            )}
                          </span>
                        </div>
                        <p>{ele.comment}</p>
                      </div>
                    );
                  })}
                </div>
              </>
            );
          })}
        {Object.keys(allComments).length === 0 && (
          <div>
            There are currently no comments associated with the selected
            documents, comments can be added below, all comments are added to
            the current active document.
          </div>
        )}
      </div>
      <div className="flex flex-col gap-4 p-4">
        <textarea
          // type="text"
          rows={3}
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          className="flex-1 px-4 py-2 border rounded-md bg-blue-50"
          placeholder={
            documentIds.length > 0
              ? `Commenting on ${documentIds[carouselIndex].documentFileName}`
              : 'Comment'
          }
        />
        <div className="flex flex-row justify-end" id="sendDiv">
          <Button onClick={() => postComment()}>Comment</Button>
        </div>
      </div>
    </div>
  );
};
